module.exports = __webpack_public_path__ + "static/img/2.bdc190c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/10/sp/2.png
// module id = bZTu
// module chunks = 0